var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("h2", [_vm._v("Lectura de Excel")])
                      ])
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-sucursal",
                              staticStyle: { "margin-top": "10px" },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.image.click()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("attach_file")])],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              xs8: "",
                              sm8: "",
                              md8: "",
                              label: "Seleccione Archivo",
                              heigh: "",
                              "error-messages": _vm.errors.collect("archivo"),
                              "data-vv-name": "archivo",
                              readonly: "readonly"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$refs.image.click()
                              }
                            },
                            model: {
                              value: _vm.fileName,
                              callback: function($$v) {
                                _vm.fileName = $$v
                              },
                              expression: "fileName"
                            }
                          }),
                          _c("input", {
                            key: _vm.idkey,
                            ref: "image",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept: ".csv, .xlsx, .xls",
                              id: "archivoExcel"
                            },
                            on: { change: _vm.subirExcel }
                          }),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.fileName,
                                  expression: "fileName"
                                }
                              ],
                              attrs: { color: "error" },
                              on: { click: _vm.quitarRegistro }
                            },
                            [_vm._v("✖")]
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("v-divider"),
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "divP", attrs: { align: "left" } },
                            [
                              _c("p", { staticClass: "aclaracion" }, [
                                _vm._v(
                                  "\n                Se recomienda utilizar el formato de la siguiente plantilla\n                para evitar conflictos al momento de cargar la solicitud.\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                Por favor, ingresar los datos según los formatos que se\n                muestran en la fila de ejemplo de la plantilla.\n              "
                                )
                              ]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btnPlantilla",
                                  attrs: {
                                    flat: "",
                                    small: "",
                                    color: "primary"
                                  },
                                  on: { click: _vm.descargarPlantilla }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "importExportBtnIcon" },
                                    [_vm._v("cloud_download")]
                                  ),
                                  _vm._v("  \n                "),
                                  _c(
                                    "span",
                                    { staticClass: "importExportBtnTexto" },
                                    [_vm._v("Descargar Plantilla")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-container",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cargarTabla,
                              expression: "cargarTabla"
                            }
                          ],
                          staticClass: "modalCargarArchivo"
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("MantenedorGrid", {
                                staticClass: "ag-theme-material",
                                staticStyle: {
                                  width: "100%",
                                  "font-family": "'Asap' sans-serif"
                                },
                                attrs: { gridOptions: _vm.gridOptions }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }